// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4194":"1c955564","6352":"1388d604"}[chunkId] + ".chunk.css";
};